/**
 * url-search-params-polyfill/index.js
 * https://www.npmjs.com/package/url-search-params-polyfill
 * MIT license
 */
/* jshint ignore:start */
(function(self){"use strict";var nativeURLSearchParams=function(){try{if(self.URLSearchParams&&new self.URLSearchParams("foo=bar").get("foo")==="bar"){return self.URLSearchParams}}catch(e){}return null}(),isSupportObjectConstructor=nativeURLSearchParams&&new nativeURLSearchParams({a:1}).toString()==="a=1",decodesPlusesCorrectly=nativeURLSearchParams&&new nativeURLSearchParams("s=%2B").get("s")==="+",__URLSearchParams__="__URLSearchParams__",encodesAmpersandsCorrectly=nativeURLSearchParams?function(){var ampersandTest=new nativeURLSearchParams;ampersandTest.append("s"," &");return ampersandTest.toString()==="s=+%26"}():true,prototype=URLSearchParamsPolyfill.prototype,iterable=!!(self.Symbol&&self.Symbol.iterator);if(nativeURLSearchParams&&isSupportObjectConstructor&&decodesPlusesCorrectly&&encodesAmpersandsCorrectly){return}function URLSearchParamsPolyfill(search){search=search||"";if(search instanceof URLSearchParams||search instanceof URLSearchParamsPolyfill){search=search.toString()}this[__URLSearchParams__]=parseToDict(search)}prototype.append=function(name,value){appendTo(this[__URLSearchParams__],name,value)};prototype["delete"]=function(name){delete this[__URLSearchParams__][name]};prototype.get=function(name){var dict=this[__URLSearchParams__];return this.has(name)?dict[name][0]:null};prototype.getAll=function(name){var dict=this[__URLSearchParams__];return this.has(name)?dict[name].slice(0):[]};prototype.has=function(name){return hasOwnProperty(this[__URLSearchParams__],name)};prototype.set=function set(name,value){this[__URLSearchParams__][name]=[""+value]};prototype.toString=function(){var dict=this[__URLSearchParams__],query=[],i,key,name,value;for(key in dict){name=encode(key);for(i=0,value=dict[key];i<value.length;i++){query.push(name+"="+encode(value[i]))}}return query.join("&")};var forSureUsePolyfill=!decodesPlusesCorrectly;var useProxy=!forSureUsePolyfill&&nativeURLSearchParams&&!isSupportObjectConstructor&&self.Proxy;var propValue;if(useProxy){propValue=new Proxy(nativeURLSearchParams,{construct:function(target,args){return new target(new URLSearchParamsPolyfill(args[0]).toString())}});propValue.toString=Function.prototype.toString.bind(URLSearchParamsPolyfill)}else{propValue=URLSearchParamsPolyfill}Object.defineProperty(self,"URLSearchParams",{value:propValue});var USPProto=self.URLSearchParams.prototype;USPProto.polyfill=true;USPProto.forEach=USPProto.forEach||function(callback,thisArg){var dict=parseToDict(this.toString());Object.getOwnPropertyNames(dict).forEach(function(name){dict[name].forEach(function(value){callback.call(thisArg,value,name,this)},this)},this)};USPProto.sort=USPProto.sort||function(){var dict=parseToDict(this.toString()),keys=[],k,i,j;for(k in dict){keys.push(k)}keys.sort();for(i=0;i<keys.length;i++){this["delete"](keys[i])}for(i=0;i<keys.length;i++){var key=keys[i],values=dict[key];for(j=0;j<values.length;j++){this.append(key,values[j])}}};USPProto.keys=USPProto.keys||function(){var items=[];this.forEach(function(item,name){items.push(name)});return makeIterator(items)};USPProto.values=USPProto.values||function(){var items=[];this.forEach(function(item){items.push(item)});return makeIterator(items)};USPProto.entries=USPProto.entries||function(){var items=[];this.forEach(function(item,name){items.push([name,item])});return makeIterator(items)};if(iterable){USPProto[self.Symbol.iterator]=USPProto[self.Symbol.iterator]||USPProto.entries}function encode(str){var replace={"!":"%21","'":"%27","(":"%28",")":"%29","~":"%7E","%20":"+","%00":"\0"};return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g,function(match){return replace[match]})}function decode(str){return str.replace(/[ +]/g,"%20").replace(/(%[a-f0-9]{2})+/gi,function(match){return decodeURIComponent(match)})}function makeIterator(arr){var iterator={next:function(){var value=arr.shift();return{done:value===undefined,value:value}}};if(iterable){iterator[self.Symbol.iterator]=function(){return iterator}}return iterator}function parseToDict(search){var dict={};if(typeof search==="object"){if(isArray(search)){for(var i=0;i<search.length;i++){var item=search[i];if(isArray(item)&&item.length===2){appendTo(dict,item[0],item[1])}else{throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements")}}}else{for(var key in search){if(search.hasOwnProperty(key)){appendTo(dict,key,search[key])}}}}else{if(search.indexOf("?")===0){search=search.slice(1)}var pairs=search.split("&");for(var j=0;j<pairs.length;j++){var value=pairs[j],index=value.indexOf("=");if(-1<index){appendTo(dict,decode(value.slice(0,index)),decode(value.slice(index+1)))}else{if(value){appendTo(dict,decode(value),"")}}}}return dict}function appendTo(dict,name,value){var val=typeof value==="string"?value:value!==null&&value!==undefined&&typeof value.toString==="function"?value.toString():JSON.stringify(value);if(hasOwnProperty(dict,name)){dict[name].push(val)}else{dict[name]=[val]}}function isArray(val){return!!val&&"[object Array]"===Object.prototype.toString.call(val)}function hasOwnProperty(obj,prop){return Object.prototype.hasOwnProperty.call(obj,prop)}})(typeof global!=="undefined"?global:typeof window!=="undefined"?window:this);
/* jshint ignore:end */

var jquery = $;
/* jshint ignore:start */
jquery.fn.highlight = function (b) { function a(e, j) { var l = 0; if (e.nodeType == 3) { var k = e.data.toUpperCase().indexOf(j); if (k >= 0) { var h = document.createElement("span"); h.className = "highlight"; var f = e.splitText(k); var c = f.splitText(j.length); var d = f.cloneNode(true); h.appendChild(d); f.parentNode.replaceChild(h, f); l = 1 } } else { if (e.nodeType == 1 && e.childNodes && !/(script|style)/i.test(e.tagName)) { for (var g = 0; g < e.childNodes.length; ++g) { g += a(e.childNodes[g], j) } } } return l } return this.each(function () { a(this, b.toUpperCase()) }) }; jquery.fn.removeHighlight = function () { return this.find("span.highlight").each(function () { this.parentNode.firstChild.nodeName; this.parentNode.replaceChild(this.parentNode.firstChild, this.parentNode); this.parentNode.normalize(); }).end() };
/* jshint ignore:end */
$(function () {
    var windowName = window.frameElement && window.frameElement.parentElement
        && window.frameElement.parentElement.getAttribute('data-window-name')

    var peekParam = window.frameElement ? new URLSearchParams(window.frameElement.src).get('peek_window') : null;
    var isPeekedProcedure = peekParam !== null && peekParam.startsWith('true');

    var peekLinks = $('a.peek-link')
    peekLinks.on('click', function (event) {
        parent.peekWindow.openPeek(event, windowName)
    })

    peekLinks.each(function(_index, element) {
        var $elem = $(element)
        var refId = $elem.attr('data-reference-id')
        var nodeId = $elem.attr('data-node-id')

        $elem.parent().append('<div class="direct-link-wrapper"><span class="direct-link"><button class="direct-link-button" onclick="window.parent.activateNodeLink(' + refId + ', ' + nodeId + ')"><i class="icon icon-external-link-sign" /></button></span></div>')
    })

    var adjustScrollHeight = function () {
        var scrollHeight = window.frameElement.contentWindow.document.body.scrollHeight + 30 + 'px';
        window.frameElement.parentElement.style.height = scrollHeight;
        window.frameElement.height = scrollHeight;
    }

    if (isPeekedProcedure) {
        adjustScrollHeight();

        var parentElement = window.frameElement.contentWindow.document.body.parentElement;
        var resizeObserver = new ResizeObserver(function (entries) {
            entries.forEach(function (entry) {
                adjustScrollHeight();
            });
        });
        resizeObserver.observe(parentElement);

    }
})

$(document).ready(function () {

    /* jshint ignore:start */
    /**
     * lodash (Custom Build) <https://lodash.com/>
     * Build: `lodash modularize exports="npm" -o ./`
     * Copyright jQuery Foundation and other contributors <https://jquery.org/>
     * Released under MIT license <https://lodash.com/license>
     * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
     * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
     * Includes _.debounce() and _.throttle
    */
    var _=function(){function z(a,b,d){function g(c){var f=k,n=m;k=m=void 0;p=c;return q=a.apply(n,f)}function l(c){var f=c-h;c-=p;return void 0===h||f>=b||0>f||r&&c>=v}function t(){var c=w.Date.now();if(l(c))return A(c);var f=setTimeout;var n=c-p;c=b-(c-h);n=r?E(c,v-n):c;e=f(t,n)}function A(c){e=void 0;if(x&&k)return g(c);k=m=void 0;return q}function y(){var c=w.Date.now(),f=l(c);k=arguments;m=this;h=c;if(f){if(void 0===e)return p=c=h,e=setTimeout(t,b),B?g(c):q;if(r)return e=setTimeout(t,b),g(h)}void 0===
    e&&(e=setTimeout(t,b));return q}var k,m,q,e,h,p=0,B=!1,r=!1,x=!0;if("function"!=typeof a)throw new TypeError("Expected a function");b=C(b)||0;if(u(d)){B=!!d.leading;var v=(r="maxWait"in d)?F(C(d.maxWait)||0,b):v;x="trailing"in d?!!d.trailing:x}y.cancel=function(){void 0!==e&&clearTimeout(e);p=0;k=h=m=e=void 0};y.flush=function(){return void 0===e?q:A(w.Date.now())};return y}function u(a){var b=typeof a;return!!a&&("object"==b||"function"==b)}function C(a){if("number"==typeof a)return a;var b=a;if("symbol"==
    typeof b||b&&"object"==typeof b&&"[object Symbol]"==G.call(b))return D;u(a)&&(a="function"==typeof a.valueOf?a.valueOf():a,a=u(a)?a+"":a);if("string"!=typeof a)return 0===a?a:+a;a=a.replace(H,"");return(b=I.test(a))||J.test(a)?K(a.slice(2),b?2:8):L.test(a)?D:+a}var D=0/0,H=/^\s+|\s+$/g,L=/^[-+]0x[0-9a-f]+$/i,I=/^0b[01]+$/i,J=/^0o[0-7]+$/i,K=parseInt,M="object"==typeof self&&self&&self.Object===Object&&self,w="object"==typeof global&&global&&global.Object===Object&&global||M||Function("return this")(),
    G=Object.prototype.toString,F=Math.max,E=Math.min;return{throttle:function(a,b,d){var g=!0,l=!0;if("function"!=typeof a)throw new TypeError("Expected a function");u(d)&&(g="leading"in d?!!d.leading:g,l="trailing"in d?!!d.trailing:l);return z(a,b,{leading:g,maxWait:b,trailing:l})},debounce:z}}();

    /* jshint ignore:end */

    var videoId;
    var bodyVidAttr = document.querySelector('body').getAttribute('data-vid');
    if (bodyVidAttr !== null && bodyVidAttr.length > 0) {
        videoId = document.querySelector('body').getAttribute('data-vid');
    } else {
        var hash = window.top.location.hash.startsWith("#") ? decodeURIComponent(window.top.location.hash).substring(1) : "";
        var regExp = new RegExp("(vid\-)([0-9]+)");
        if (regExp.test(hash)) {
           videoId = regExp.exec(hash)[2];
        } else {
            // Temp workaround as api returns vid id in the wrong place.
            var locationParam = new URLSearchParams(window.location.search).get('location')
            let urlHash = window.location.hash
            if (urlHash)
            {
                let hash = urlHash.substring(1);
                var split = hash.split('!');
                if (split.length === 5) {
                    videoId = split[4];
                }
            }
        }
    }
    var scrolledToSearch = false;
    if (typeof searchTerms != 'undefined' && searchTerms != null) {
        scrolledToSearch = true;
        var page = jquery('body').find('*');
        for (var term in searchTerms) {
            page.highlight(searchTerms[term]);
        }
        // scroll to the first term after a short delay.
        if ($('.highlight:first').length && $("iframe", window.parent.document).length < 2) {
            setTimeout("scrollToFirstTerm();", 600);
        }
    }

    $('video').bind('contextmenu', function() { return false; });

    /**
     * Handle responsive video / iframe resize
     */
    $(window).on('load', function (_event) {
        var videoElemList = $('video'),
            SCREEN_CHANGE_EVENTS = 'webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange',
            parentTarget = window.parent,
            messageResize = { type: 'action', action: 'resizeIframe' },
            // Share same throttle state across all events to prevent too many updates
            throttledMessage = _.throttle(function () {
                parentTarget.postMessage(messageResize, window.location.origin);
            }, 350);

        $(window).on('resize scroll', throttledMessage);

        if (videoElemList.length) {

            shouldToggleVidElem();
            $(window).on('resize', _.throttle(shouldToggleVidElem, 100));

            $('.video-still').on('click', function (event) {

                var videoStillElem = this,
                    $videoElem = $(videoStillElem).prev();

                if (this.requestFullscreen) {
                    $videoElem.addClass('fullscreened');
                    $videoElem[0].requestFullscreen();
                    onScreenChange($videoElem);
                } else if (this.mozRequestFullScreen) { /* Firefox */
                    $videoElem.addClass('fullscreened');
                    $videoElem[0].mozRequestFullScreen();
                    onScreenChange($videoElem);
                } else if (this.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                    $videoElem.addClass('fullscreened');
                    $videoElem[0].webkitRequestFullscreen();
                    onScreenChange($videoElem);
                } else if (this.msRequestFullscreen) { /* IE/Edge */
                    $videoElem.addClass('fullscreened');
                    $videoElem[0].msRequestFullscreen();
                    onScreenChange($videoElem);
                }
            });

            // Force reload on first load
            parentTarget.postMessage(messageResize, window.location.origin);
        }

        function shouldToggleVidElem() {

            videoElemList.each(function (index, elem) {
                var $elem = $(elem),
                    $elemContainer = $elem.parent(),
                    $elemContainerWidth = $elemContainer.outerWidth(),
                    $windowWidth = $(window).width();

                if ($windowWidth < 320 || $elemContainerWidth <= 200) {
                    handleToggleVidElem($elem, true);
                    $elem[0].pause();

                } else if ($windowWidth >= 320 || $elemContainerWidth) {
                    handleToggleVidElem($elem, false);
                }
            });

            function handleToggleVidElem(elem, addClass) {
                if (addClass) {
                    elem.addClass('video-player-hide');
                } else {
                    elem.removeClass('video-player-hide');
                }

                // Send message to resize
                throttledMessage();
            }

        }

        function onScreenChange(videoElem) {
            // checkFullscreen seems to fire soon after event attachment, var to stop first fire
            var isFirstChange = true;

            function checkFullscreen(event) {
                if ((!document.fullscreenElement ||
                    !document.webkitFullscreenElement ||
                    !document.mozFullScreenElement ||
                    !document.msFullscreenElement) && !isFirstChange) {
                        videoElem[0].pause();
                        videoElem.removeClass('fullscreened');
                        $(document).off(SCREEN_CHANGE_EVENTS, checkFullscreen);
                } else {
                    isFirstChange = false;
                }
            }

            // Check if out of fullscreen
            $(document).on(SCREEN_CHANGE_EVENTS, checkFullscreen);
        }

    });

    $(function () {
        $("a").each(function () {
            var link = $(this);
            var href = link.attr("href");
            if (href && href[0] == "#") {
                // Name could be an empty string that could get us to query $('#') which throws an error in jQuery
                var name = href.substring(1) ? href.substring(1) : 'undefined' ;
                $(this).on('click', function (event) {
                    var $body = $(this).parents('body'),
                        uid = $body.data('uid'),
                        nid = $body.data('nid');
                    if (uid !== "" && nid !== "") {
                        var $procedureIframe = $("#procedure-iframe-" + nid + "-" + uid, window.parent.document),
                            $procedureIframeParent = $procedureIframe.parent(),
                            $procedureContent = $(window.parent.document).find('.procedure-content'),
                            nameElement = $("[name='" + name + "']"),
                            idElement = $("#" + name),
                            element = null;
                        if (nameElement.length > 0) {
                            element = nameElement;
                        } else if (idElement.length > 0) {
                            element = idElement;
                        }

                        if (element) {
                            var elementOffset = element.offset();

                            var isPeekWindow = (new URL(document.location)).searchParams.get('peek_window') === 'true'
                            if (isPeekWindow) {
                                // Handle scrolling within a peek window
                                if (window.frameElement ) {
                                    var $iframeWrapper = $(window.frameElement.parentElement);
                                    var $peekWrapper = $(window.frameElement.parentElement.parentElement);
                                    $peekWrapper.animate({ scrollTop: elementOffset.top + $iframeWrapper.position().top + $peekWrapper.scrollTop() });
                                } else
                                {
                                    $('html').animate({ scrollTop: elementOffset.top })
                                }
                            } else {
                                $procedureContent.animate({ scrollTop: elementOffset.top + $procedureIframeParent.position().top + $procedureContent.scrollTop() });
                            }
                        }

                        return false;
                    }
                });
            }
        });
    });

    if (!scrolledToSearch && videoId != null) {
        var scrollTarget;
        var targetVideo =  document.querySelector('video[videoRef="'+ videoId +'"]');
        if (targetVideo != null) {
            var parent = targetVideo.closest('div.figure');
            if (parent != null) {
                scrollTarget = parent;
            } else {
                scrollTarget = targetVideo;
            }
            setTimeout(function (){
                scrollTarget.classList.add('video-highlight');
                scrollTarget.scrollIntoView();
            }, 600);
        }
    }
});

function scrollToFirstTerm() {
    var term = $('.highlight:first');
    $procedureContent = $(window.parent.document).find('.procedure-content');
    $procedureContent.animate({ scrollTop: term.offset().top }, 1);
}

function moviePopUp(uid, imagePath) {
    imagePath = null; // imagePath is not currently used.
    var width = screen.width;
    var height = screen.height;
    var top = ((height - 276) / 2) < 0 ? 0 : ((height - 276) / 2);
    var left = ((width - 486) / 2) < 0 ? 0 : ((width - 486) / 2);
    var playerWindow = window.open('/sip/content/video/view?sourceId=' + uid, '', 'width=486,height=276,scrollbars=no,resizable=yes,toolbar=no,location=no,menubar=no,status=no,directories=no,titlebar=no,top=' + top + ',left=' + left);
    try {
        playerWindow.moveTo(left, top); // force move in case the pop up position was ignored.
    }
    catch (err) {
        // ignore.
    }
    playerWindow.focus();
}
